import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

const MissionReportPage_Report_UpdatePrintSettings_Mutation = graphql(`
  mutation MissionReportPage_Report_UpdatePrintSettings(
    $printableId: Id!
    $printSettings: PrintSettingsInput!
  ) {
    updateReportPrintSettings(
      printableId: $printableId
      printSettings: $printSettings
    ) {
      _id
    }
  }
`);

export const useUpdateReportPrintSettingsMutation = () =>
  useGraphQLMutation(MissionReportPage_Report_UpdatePrintSettings_Mutation);
